import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "position-relative h-100" };
const _hoisted_2 = { class: "table border-top-0" };
const _hoisted_3 = { class: "font-weight-bold" };
const _hoisted_4 = { class: "border-top-0 col-1 fw-bold text-center" };
const _hoisted_5 = { class: "border-top-0 col-4" };
const _hoisted_6 = { class: "border-top-0 col-1 text-center" };
const _hoisted_7 = { class: "border-top-0 col-2 d-none d-md-table-cell text-end" };
const _hoisted_8 = { class: "border-top-0 col-6 col-xl-4 text-end" };
const _hoisted_9 = { class: "col-1fw-bold text-center align-middle" };
const _hoisted_10 = { class: "col-4 align-middle" };
const _hoisted_11 = { class: "col-1 text-center align-middle" };
const _hoisted_12 = { class: "col-2 text-end d-none d-md-table-cell align-middle" };
const _hoisted_13 = { class: "col-6 col-xl-4 text-end pb-3 pt-3 sh-1" };
const _hoisted_14 = { class: "btn-group d-none d-xxl-inline-flex" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("button", { class: "btn btn-primary btn-sm" }, "Bestellen", -1);
const _hoisted_16 = { class: "btn-group d-none d-xxl-inline-flex" };
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
    key: 1,
    class: "btn-group d-none d-xxl-inline-flex"
};
const _hoisted_19 = { class: "btn btn-primary btn-sm" };
const _hoisted_20 = { class: "btn-group" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("button", {
    class: "btn btn-sm btn-outline-primary dropdown-toggle",
    type: "button",
    id: "cmdCartActions",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
}, " Aktionen ", -1);
const _hoisted_22 = {
    class: "dropdown-menu dropdown-menu-end",
    "aria-labelledby": "cmdCartActions"
};
const _hoisted_23 = /*#__PURE__*/ _createTextVNode(" Bestellen ");
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { key: 1 };
const _hoisted_26 = { key: 2 };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" }, null, -1);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("hr", { class: "dropdown-divider" })
], -1);
const _hoisted_31 = { key: 4 };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { key: 5 };
const _hoisted_34 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_loader = _resolveComponent("g-loader");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.OnCreate()), ["prevent"]))
                    }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Create')), 1)
                ])
            ]),
            _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
            (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
                : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_2, [
                _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$tc(`client.Commerce.${this.cartType === 'L' ? 'OrderLists' : 'Carts'}.Title`)), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Caption')), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Lines')), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Amount')), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Commands')), 1)
                    ])
                ]),
                _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carts, (cart) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", _hoisted_9, _toDisplayString(cart.cartNumber), 1),
                            _createElementVNode("td", _hoisted_10, _toDisplayString(cart.cartName), 1),
                            _createElementVNode("td", _hoisted_11, _toDisplayString(cart.lineCount), 1),
                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$utils.formatNumberWithDcp(cart.totalNetAmount, 2)) + " " + _toDisplayString(cart.currency), 1),
                            _createElementVNode("td", _hoisted_13, [
                                (cart.cartType === 'L')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_component_router_link, {
                                                to: '/order-lists/' + cart.cartID
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_15
                                                ]),
                                                _: 2
                                            }, 1032, ["to"])
                                        ]),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("button", {
                                                class: "btn btn-success btn-sm",
                                                onClick: _withModifiers(($event) => (_ctx.OnOrderListSend(cart)), ["stop", "prevent"])
                                            }, "Absenden", 8, _hoisted_17)
                                        ])
                                    ], 64))
                                    : (cart.lineCount > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createVNode(_component_router_link, {
                                                to: '/checkout/' + cart.cartID
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Checkout')), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to"])
                                        ]))
                                        : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createElementVNode("ul", _hoisted_22, [
                                        (cart.cartType === 'L')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("li", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: '/order-lists/' + cart.cartID,
                                                        class: "dropdown-item"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_23
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        onClick: _withModifiers(($event) => (_ctx.dOnOrderListSend(cart)), ["stop", "prevent"]),
                                                        class: "dropdown-item"
                                                    }, "Absenden", 8, _hoisted_24)
                                                ])
                                            ], 64))
                                            : (cart.lineCount > 0)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                                    _createVNode(_component_router_link, {
                                                        to: '/checkout/' + cart.cartID,
                                                        class: "dropdown-item"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Checkout')), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]))
                                                : _createCommentVNode("", true),
                                        (cart.cartType === 'L' || cart.lineCount > 0)
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, _hoisted_28))
                                            : _createCommentVNode("", true),
                                        (cart.cartType === 'L')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("a", {
                                                        href: "#",
                                                        onClick: _withModifiers(($event) => (_ctx.OnOrderListToCart(cart)), ["stop", "prevent"]),
                                                        class: "dropdown-item"
                                                    }, "In Warenkorb umwandeln", 8, _hoisted_29)
                                                ]),
                                                _hoisted_30
                                            ], 64))
                                            : _createCommentVNode("", true),
                                        (cart.cartState !== 'A')
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                                _createElementVNode("a", {
                                                    href: "#",
                                                    onClick: _withModifiers(($event) => (_ctx.renameCart(cart)), ["stop", "prevent"]),
                                                    class: "dropdown-item"
                                                }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Rename')), 9, _hoisted_32)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (cart.cartState !== 'A')
                                            ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                                _createElementVNode("a", {
                                                    href: "#",
                                                    onClick: _withModifiers(($event) => (_ctx.deleteCart(cart)), ["stop", "prevent"]),
                                                    class: "dropdown-item"
                                                }, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Command.Delete')), 9, _hoisted_34)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ]));
                    }), 256))
                ])
            ])
        ])
    ], 64));
}
